import React, { useState, useRef, useEffect } from "react";

import {
  Table,
  Card,
  CardBody,
  CardTitle,
  Button,
  Collapse,
  Row,
} from "reactstrap";

import SweetAlert from "react-bootstrap-sweetalert";
import { useLocation } from "react-router-dom";
//redux
import { connect } from "react-redux";
//paginação
import Pagination from "../../../components/Paginationv3";
//useQuery
import { useQueries } from "react-query";
//componentes
import ModalNewHotel from "./ModalNewHotel";
import ModalEditHotel from "./ModalEditHotel";
import ModalAllImports from "./ModalAllImports";
import SearchFilters from "../../../components/SearchFilters";
import TableHotel from "./tableHotel";
import WaitExport from "../../../components/WaitExport";
import SectionComponent from "../../Apps/Personalization/SectionComponent";
import ModalLinksEmbeded from "../Voo/ModalLinksEmbeded";
import ActionButtonRounded from "../../../components/Buttons/ActionButtonRounded";
import ModalConfirmDeleteAll from "../../../components/ModalConfirmDeleteAll";
import LoadingSkelentonTable from "../../../components/loadingSkeletonTable";
//service e utils
import { getHotel, deleteAllHotels } from "../../../utils/services/hotel";
import { getParticipantsLogistic } from "../../../utils/services/participants";
import useDebounce from "../../../utils/hooks/useDebounce";
import { createXlsx } from "./createXlsx";

const columnsFilter = [
  { name: "Participante", value: "login", type: "text" },
  { name: "Hotel", value: "hotel", type: "text" },
  { name: "Check In", value: "checkindate", type: "date" },
  { name: "Check Out", value: "checkoutdate", type: "date" },
];

function Hotel(props) {
  const location = useLocation();
  const idEvent = location.state.idEvent;
  //pesquisa
  const [search, setSearch] = useState("");
  //modais
  const [modalNewHotel, setModalNewHotel] = useState(false);
  const [modalEditHotel, setModalEditHotel] = useState(false);
  const [modalLinksEmbeded, setModalLinksEmbeded] = useState(false);
  const [modalAllImports, setModalAllImports] = useState(false);
  const [modalDeleteAll, setModalDeleteAll] = useState(false);
  //deletar participante
  const [success_dlg, setsuccess_dlg] = useState(false);
  const [dynamic_title, setdynamic_title] = useState("");
  const [dynamic_description, setdynamic_description] = useState("");
  //editar participante
  const [editHotel, setEditHotel] = useState();
  //state de hotels
  const [hotels, setHotels] = useState([]);
  //state de participants
  // const [participants, setParticipants] = useState([]);
  const participants = useRef(null);
  // exibir botão deletar todos
  const [showDeleteAll, setShowDeleteAll] = useState(false);

  // eslint-disable-next-line no-unused-vars
  const [countData, setCountData] = useState(1);
  //paginação
  const [currentIndex, setCurrentIndex] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const debouncedSearch = useDebounce(search, 300);

  // export in progress
  const [exportInProgress, setExportInProgress] = useState(false);
  const [finishExport, setFinishExport] = useState(false);

  // collapse
  const [isOpen, setIsOpen] = useState(false);
  const [collapseIsOpen, setCollapseIsOpen] = useState(false);
  const [activeFilter, setActiveFilter] = useState("login");

  function setActiveFilterHandle(columnActive) {
    setActiveFilter(columnActive);
    setSearch("");
  }
  const reverseDate = () => {
    const reverse = debouncedSearch
      .split("/")
      .reverse()
      .join("/")
      .replace(/\//g, "-");
    return reverse;
  };

  function treatmentSearch() {
    if (
      columnsFilter.filter((item) => item.value === activeFilter)[0].type ===
      "date"
    ) {
      return reverseDate();
    }
    return debouncedSearch;
  }

  function toggleNewHotel() {
    setModalNewHotel(!modalNewHotel);
  }

  function toggleEditHotel() {
    setModalEditHotel(!modalEditHotel);
  }

  async function confirmDeleteAllHotels() {
    await deleteAllHotels({
      jwt: props.state.global_user_data.data.token,
      eventId: idEvent,
    }).then((response) => {
      setsuccess_dlg(true);
      setdynamic_title("Sucesso");
      setdynamic_description("Hotéis deletados com sucesso");
    });
  }
  const data = useQueries([
    {
      queryKey: ["getAllParticipants" + idEvent, 1],
      queryFn: async () => {
        const partForm = await getParticipantsLogistic({
          jwt: props.state.global_user_data.data.token,
          idEvent: idEvent,
          offset: 0,
          limit: 0,
          search: "",
        });
        participants.current = partForm?.data?.data;
      },
    },
    {
      queryKey: [
        "getAllHotels" +
          idEvent +
          currentIndex +
          itemsPerPage +
          debouncedSearch,
        2,
      ],
      notifyOnChangeProps: ["currentIndex"],
      queryFn: async () => {
        const hotelsData = await getHotel({
          jwt: props.state.global_user_data.data.token,
          idEvent: idEvent,
          offset: currentIndex > 0 ? currentIndex : 1,
          limit: itemsPerPage,
          search: treatmentSearch(),
          columnSearch: activeFilter,
        });
        setCountData(hotelsData.findOneHotelData.count);
        setHotels(hotelsData.findOneHotelData.data);
      },
    },
  ]);

  useEffect(() => {
    getParticipantsLogistic({
      jwt: props.state.global_user_data.data.token,
      idEvent: idEvent,
      offset: 0,
      limit: 0,
      search: "",
    }).then((partForm) => {
      participants.current = partForm?.data?.data;
    });
    getHotel({
      jwt: props.state.global_user_data.data.token,
      idEvent: idEvent,
      offset: currentIndex > 0 ? currentIndex : 1,
      limit: itemsPerPage,
      search: debouncedSearch,
    }).then((hotelsData) => {
      setCountData(hotelsData.findOneHotelData.count);
      setHotels(hotelsData.findOneHotelData.data);
    });
  }, []);

  return (
    <div>
      {modalDeleteAll && (
        <ModalConfirmDeleteAll
          isOpen={modalDeleteAll}
          toggle={() => setModalDeleteAll(false)}
          title="Deletar Hotéis"
          onConfirm={confirmDeleteAllHotels}
        />
      )}

      {modalNewHotel && (
        <ModalNewHotel
          isOpen={modalNewHotel}
          toggle={toggleNewHotel}
          idEvent={idEvent}
          data={() => {
            data[0].refetch();
            data[1].refetch();
          }}
          participants={participants?.current}
        />
      )}

      {modalEditHotel && (
        <ModalEditHotel
          isOpen={modalEditHotel}
          toggle={toggleEditHotel}
          idEvent={idEvent}
          data={data}
          editHotel={editHotel}
          participants={participants.current}
        />
      )}

      {modalLinksEmbeded && (
        <ModalLinksEmbeded
          isOpen={modalLinksEmbeded}
          toggle={() => setModalLinksEmbeded(false)}
          eventId={idEvent}
        />
      )}

      {modalAllImports && (
        <ModalAllImports
          isOpen={modalAllImports}
          toggle={() => setModalAllImports(false)}
          idEvent={idEvent}
          data={() => {
            data[0]?.refetch();
            data[1]?.refetch();
          }}
        />
      )}

      {success_dlg ? (
        <SweetAlert
          success
          title={dynamic_title}
          onConfirm={() => {
            data[0].refetch();
            data[1].refetch();
            setsuccess_dlg(false);
          }}
        >
          {dynamic_description}
        </SweetAlert>
      ) : null}
      <WaitExport
        isOpen={exportInProgress}
        name="Hoteis"
        preposicao="dos"
        finishExport={finishExport}
        setFinishExport={setFinishExport}
        setExportInProgress={setExportInProgress}
      />
      <Card>
        <CardBody>
          <CardTitle>Hotel</CardTitle>
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              marginBottom: 10,
            }}
          >
            <Button
              color="success"
              className="btn-rounded waves-effect waves-light events-button-add"
              style={{ marginRight: 10 }}
              onClick={() => setModalLinksEmbeded(true)}
            >
              Links Para Embedar
            </Button>
          </div>

          <div>
            <Row
              style={{
                display: "flex",
                flexDirection: "row",
                marginBottom: 10,
                width: "50px",
              }}
            >
              <SectionComponent
                sectionName="Filtros"
                setIsOpen={setCollapseIsOpen}
                isOpen={collapseIsOpen}
              />
            </Row>
            <Collapse isOpen={collapseIsOpen}>
              <SearchFilters
                columns={columnsFilter}
                activeFilter={activeFilter}
                setActiveFilterHandle={setActiveFilterHandle}
              />
            </Collapse>
          </div>
          <div
            style={{
              display: "flex",
              width: "100%",
              justifyContent: "space-between",
              marginBottom: 10,
            }}
          >
            <form
              className="app-search d-none d-lg-block events-input-search"
              onSubmit={(e) => e.preventDefault()}
            >
              <div className="position-relative">
                <input
                  value={search}
                  type={
                    activeFilter === "checkindate" ||
                    activeFilter === "checkoutdate"
                      ? "date"
                      : "text"
                  }
                  className="form-control"
                  placeholder="Pesquisar..."
                  onChange={(e) => setSearch(e.target.value)}
                />
                <span className="bx bx-search-alt" />
              </div>
            </form>
            <div className="mobile-btn-section" style={{ width: "100%" }}>
              <Row className="mobile-btns-top">
                <form
                  className="app-search"
                  style={{ padding: "0px" }}
                  onSubmit={(e) => e.preventDefault()}
                >
                  <div className="position-relative">
                    <input
                      type={
                        activeFilter === "checkindate" ||
                        activeFilter === "checkoutdate"
                          ? "date"
                          : "text"
                      }
                      value={search}
                      className="form-control"
                      placeholder="Pesquisar..."
                      onChange={(e) => setSearch(e.target.value)}
                    />
                    <span className="bx bx-search-alt" />
                  </div>
                </form>
              </Row>
              <SectionComponent
                sectionName="Opções"
                setIsOpen={setIsOpen}
                isOpen={isOpen}
              />
              <Collapse isOpen={isOpen}>
                {hotels.length > 0 && (
                  <Row className="mobile-btns-top">
                    <div
                      onClick={() =>
                        createXlsx({
                          jwt: props.state.global_user_data.data.token,
                          idEvent: idEvent,
                          limit: 100,
                          countData,
                          setFinishExport,
                        }) > setExportInProgress(true)
                      }
                    >
                      Exportar Hotéis
                    </div>
                  </Row>
                )}
                <ActionButtonRounded
                  title="Importar Hotéis"
                  onClick={() => setModalAllImports(true)}
                  type="mobile"
                />

                <ActionButtonRounded
                  title="Adicionar Hotel"
                  onClick={() => setModalNewHotel(true)}
                  type="mobile"
                />
              </Collapse>
            </div>
            <div className="header-btns-container">
              {hotels?.length > 0 && (
                <Button
                  color="success"
                  className="btn-rounded waves-effect waves-light events-button-add"
                  onClick={() =>
                    createXlsx({
                      jwt: props.state.global_user_data.data.token,
                      idEvent: idEvent,
                      limit: 100,
                      countData,
                      setFinishExport,
                    }) > setExportInProgress(true)
                  }
                >
                  Exportar Hotéis
                </Button>
              )}
              <ActionButtonRounded
                title="Importar Hotéis"
                onClick={() => setModalAllImports(true)}
                margin={"0 5px"}
              />

              <ActionButtonRounded
                title="Adicionar Hotel"
                onClick={() => setModalNewHotel(true)}
              />
            </div>
          </div>

          {data[1].isFetching ? (
            <div className="table-responsive">
              <Table>
                <thead className="table-light">
                  <tr>
                    <th>Participante</th>
                    <th>Hotel</th>
                    <th>Data/hora checkIn</th>
                    <th>Data/hora checkOut</th>
                    <th>Ações</th>
                  </tr>
                </thead>
                <tbody>
                  <LoadingSkelentonTable lines={10} cols={5} />
                </tbody>
              </Table>
            </div>
          ) : (
            <TableHotel
              hotels={hotels}
              idEvent={idEvent}
              participants={participants?.current}
              data={() => {
                data[0].refetch();
                data[1].refetch();
              }}
            />
          )}
        </CardBody>
      </Card>
      <div
        className="bottom-navigation"
        style={{
          justifyContent: `${
            hotels?.length > 0 && showDeleteAll ? "space-between" : "end"
          }`,
        }}
      >
        {hotels?.length > 0 && (
          <ActionButtonRounded
            onClick={() => setModalDeleteAll(true)}
            title="Limpar Todos Hotéis"
            action="D"
            color="danger"
            setShow={setShowDeleteAll}
            verifyShow={true}
          />
        )}
        {/* 
        Fornecer os 4 parametros obrigatórios;
        ** data - a array contendo as informações da tabela
        ** search - o state do termo de pesquisa
        ** currentIndex - posição atual do index
        ** setCurrentIndex - função para atualizar a posição atual do index
        */}
        <Pagination
          data={hotels}
          search={search}
          currentIndex={currentIndex}
          setCurrentIndex={setCurrentIndex}
          countData={countData}
          maxItemPerPage={itemsPerPage}
          setMaxItemPerPage={setItemsPerPage}
          maxPageButtonsToShow={3}
        />
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  return { state };
};

export default connect(mapStateToProps)(Hotel);
